import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity, type EntityData } from '@adornis/baseql/entities/adornisEntity.js';
import { isDefined } from '../util.js';

export function mergeRegistrationColorDefinitions(
  ...colorDefinitions: Maybe<RegistrationColorDefinitions>[]
): RegistrationColorDefinitions {
  const nonEmptyDefs = colorDefinitions.filter(isDefined);
  if (nonEmptyDefs.length === 0) throw new Error('at least one non empty definition has to be provided');

  const mergedData = {} as EntityData<RegistrationColorDefinitions>;

  for (const def of nonEmptyDefs) {
    for (const [key, value] of Object.entries(def.toObject())) {
      // apply only if not already set
      if (!!value && !mergedData[key]) mergedData[key] = value;
    }
  }

  return new RegistrationColorDefinitions(mergedData);
}

@Entity()
export class ColorDefinitions extends AdornisEntity {
  static override _class = 'ColorDefinitions';

  @Field(type => String, { default: v => v ?? '#00628f' })
  accentColor!: string;

  @Field(type => RegistrationColorDefinitions, { default: v => v ?? new RegistrationColorDefinitions({}) })
  registrationColorDefinitions!: RegistrationColorDefinitions;

  @Field(type => MailColorDefinitions, { default: v => v ?? new MailColorDefinitions({}) })
  mailColorDefinitions!: MailColorDefinitions;
}

@Entity()
export class RegistrationColorDefinitions extends AdornisEntity {
  static override _class = 'RegistrationColorDefinitions';

  @Field(type => String)
  stepColor!: string;

  @Field(type => String)
  stepFontColor!: string;

  @Field(type => String)
  productColor!: string;

  @Field(type => String)
  productFontColor!: string;

  @Field(type => String)
  moreProductsColor!: string;

  @Field(type => String)
  moreProductsFontColor!: string;

  @Field(type => String)
  chipInfosColor!: string;

  @Field(type => String)
  chipInfosFontColor!: string;

  @Field(type => String)
  oldPriceColor!: string;

  @Field(type => String)
  newPriceColor!: string;

  @Field(type => String)
  layoutLightContrastColor!: string;

  @Field(type => String)
  warnColor!: string;
}

@Entity()
export class MailColorDefinitions extends AdornisEntity {
  static override _class = 'MailColorDefinitions';

  @Field(type => String)
  accentColor!: string;

  @Field(type => String)
  accentContrastFontColor!: string;
}
